import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import EventSignUpButton from './EventSignUpButton';
import Grid from '../../../components/Grid';
import Icon from '../../../components/Icon';
import messages from './messages';
import {
  getCollegeEventDetailsClicked,
  getCollegeRecommendedEventProfileLinkClicked,
  getRegistrationLinkClicked,
} from '../../../utils/clickTrackingManager';
import { parseEvent } from './eventsHelper';

class CollegeEventRow extends React.PureComponent {
  static propTypes = {
    intl: PropTypes.object,
    event: PropTypes.object.isRequired,
    userData: PropTypes.object,
    handleClickTracking: PropTypes.func.isRequired,
    hasCoppaFerpaBlock: PropTypes.bool,
    hasFerpaBlock: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      viewMore: false,
    };
  }

  handleViewMoreClick = (viewMore) => {
    const { event, handleClickTracking } = this.props;
    this.setState({ viewMore: !viewMore });
    handleClickTracking(getCollegeEventDetailsClicked(event));
  };

  handleRegistrationUrlClicked = () => {
    const { event, handleClickTracking } = this.props;
    handleClickTracking(getRegistrationLinkClicked(event));
  };

  handleRecommendedEventClicked = (recommendedEvent) => {
    const { event, handleClickTracking } = this.props;
    if (recommendedEvent) {
      handleClickTracking(getCollegeRecommendedEventProfileLinkClicked(event));
    }
  };

  renderSignUpButton = (registrationUrl) => {
    return (
      <EventSignUpButton
        hasCoppaFerpaBlock={this.props.hasCoppaFerpaBlock}
        hasFerpaBlock={this.props.hasFerpaBlock}
        registrationUrl={registrationUrl}
        showTooltip={this.state.showTooltip}
        toggleTooltipOn={() => this.setState({ showTooltip: true })}
        toggleTooltipOff={() => this.setState({ showTooltip: false })}
        handleRegistrationUrlClicked={this.handleRegistrationUrlClicked}
      />
    );
  };

  render() {
    const { event, intl } = this.props;
    const { viewMore } = this.state;
    const {
      location,
      registrationUrl,
      fullDay,
      nrMonth,
      startHour,
      endHour,
      timezone,
    } = parseEvent(event);
    return (
      <div className="grid-container">
        <Grid stackable>
          <Grid.Row className="event-f-row">
            <Grid.Column computer={3} mobile={12} tablet={16}>
              <Grid>
                <Grid.Row>
                  <Grid.Column
                    className="event-row-date-column"
                    only="computer"
                    width={15}
                  >
                    <div className="event-row-date" data-cy="event-row-date">
                      <div>{fullDay}</div>
                      <div className="day">{nrMonth}</div>
                      <div className="hour">
                        {startHour} - {endHour} {timezone}
                      </div>
                    </div>
                  </Grid.Column>
                  <Grid.Column only="tablet mobile" mobile={15} tablet={16}>
                    <div className="event-row-date" data-cy="event-row-date">
                      <div>
                        {fullDay}, {nrMonth}
                      </div>
                      <div className="hour">
                        {startHour} - {endHour} {timezone}
                      </div>
                    </div>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Grid.Column>
            <Grid.Column width={7}>
              <Grid className="event-column-grid">
                <Grid.Row>
                  <Grid.Column>
                    <div
                      className="event-row-college-name"
                      data-cy="event-row-college"
                      onClick={() =>
                        this.handleRecommendedEventClicked(event.recommended)
                      }
                    >
                      <a
                        href={'/colleges/hubs/' + event.college.scid}
                        data-navi-donottranslate
                      >
                        {event.college.name}
                      </a>
                    </div>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column data-cy="event-row-event">
                    <div className="event-row-name">
                      <a href={'/colleges/hubs/' + event.college.scid}>{event.name} </a>
                      {event.recommended && !this.props.hasCoppaFerpaBlock && (
                        <div
                          className="event-row-recommended hide"
                          data-cy="event-row-recommended"
                        >
                          <Icon name="flag" />
                          <FormattedMessage {...messages.recommended} />
                        </div>
                      )}
                    </div>
                    {event.eventDescription && (
                      <div
                        className="event-row-view more"
                        onClick={() => this.handleViewMoreClick(viewMore)}
                        data-cy="event-view-toggle-more"
                      >
                        {!viewMore ? intl.formatMessage(messages.moredetails) : ''}
                      </div>
                    )}
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Grid.Column>
            <Grid.Column width={2}>
              <Grid>
                <Grid.Row>
                  <Grid.Column mobile={1}>
                    <Icon name="map pin" className="show" />
                  </Grid.Column>
                  <Grid.Column mobile={7} computer={12} className="event-column-location">
                    {!event.virtual && location ? (
                      <div data-cy="event-row-location-physical">
                        <div className="event-row-location-name">{location.name}</div>
                        <div className="event-row-location-street">
                          {location.street} {location.street2}
                        </div>
                        <div className="event-row-location-city">
                          {location.city}, {location.state} {location.zipCode.zipCode}
                        </div>
                      </div>
                    ) : (
                      <div data-cy="event-row-location-virtual">
                        <div className="event-row-location-name">
                          <Icon name="computer" />
                          <FormattedMessage {...messages.virtualEvent} />
                        </div>
                      </div>
                    )}
                  </Grid.Column>
                  <Grid.Column
                    only="mobile"
                    mobile={7}
                    className="event-column-recommended mobile"
                  >
                    {event.recommended && !this.props.hasCoppaFerpaBlock && (
                      <div className="event-row-recommended mobile">
                        <Icon name="flag" />
                        <FormattedMessage {...messages.recommendedMobile} />
                      </div>
                    )}
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Grid.Column>
            <Grid.Column width={3}>
              {this.renderSignUpButton(registrationUrl)}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className="event-s-row">
            <Grid.Column width={3} only="computer" />
            <Grid.Column width={10}>
              <div data-cy="event-row-description">
                {viewMore && (
                  <div className="event-row-description">{event.eventDescription}</div>
                )}
                {event.eventDescription && (
                  <div
                    className="event-row-view"
                    onClick={() => {
                      this.setState({ viewMore: !viewMore });
                    }}
                    data-cy="event-view-toggle-less"
                  >
                    {viewMore ? intl.formatMessage(messages.fewerdetails) : ''}
                  </div>
                )}
                {!event.eventDescription && (
                  <div className="event-row-no-details">
                    <FormattedMessage {...messages.nodetails} />
                  </div>
                )}
              </div>
            </Grid.Column>
            <Grid.Column only="mobile">
              {this.renderSignUpButton(registrationUrl)}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

export default injectIntl(CollegeEventRow);
